import { render, staticRenderFns } from "./LadderPrice.vue?vue&type=template&id=81063f1c&"
import script from "./LadderPrice.vue?vue&type=script&lang=js&"
export * from "./LadderPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports